import axios from "axios";
import { api, headers } from "../../app/conf";
import { makeQuery } from "../../shared/helpers/commons";

export const getDevices = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/devices?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });

export const getDevicesStatuses = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/devices/statuses?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });

    export const getDevicesSubstatuses = (filters, token) =>
        axios({
            method: "get",
            url: `${api}/devices/substatus?${makeQuery(filters)}`,
            headers: {
                ...headers,
                "X-Access-Token": token
            }
        });

export const getHistoryDevices = (imei, token) =>
    axios({
        method: "get",
        url: `${api}/devices/history/${imei}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });

export const postBatchDevices = (device, token) =>
    axios({
        method: "post",
        url: `${api}/devices/batch?tz=${new Date().getTimezoneOffset()}`,
        headers: {
            "Content-Type": "multipart/form-data",
            "X-Access-Token": token
        },
        data: device
    });

export const postValidateBatchDevices = (device, token) =>
    axios({
        method: "post",
        url: `${api}/devices/batch/validations?tz=${new Date().getTimezoneOffset()}`,
        headers: {
            "Content-Type": "form-urlencoded",
            "X-Access-Token": token
        },
        data: device
    });

export const putDevice = (device, token) =>
    axios({
        method: "put",
        url: `${api}/devices/${device.imei}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: device
});

export const patchDevice = (device, token) =>
    axios({
        method: "patch",
        url: `${api}/devices/batch`,
        headers: {
            ...headers,
            'Content-Type': 'application/json',
            "X-Access-Token": token
        },
        data: device
    });

export const postDevicesStatuses = (status, token) =>
    axios({
        method: "post",
        url: `${api}/devices/statuses`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: status
    });

export const putDevicesStatuses = (status, token) =>
    axios({
        method: "put",
        url: `${api}/devices/statuses/${status._id}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: status
    });

export const getExportDevicesService = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/devices/export?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        responseType: 'blob'
    });